import React, { Component } from 'react';
import { Table, DatePicker, Button, Pagination, message, Select } from 'antd';
import moment from 'moment';
import API_URL from '../../common/url';
import AjaxRequest from '../../common/AjaxRequest';
import SideNav from "./SideNav";
import { AddNextWeekPlan, ExportModal } from './MyWeeklyModal';
import MyWeeklyTable from './MyWeeklyTable';
import SearchSelect from '../common/SearchSelect';

const { Option } = Select;
const DateFormat = 'YYYY-MM-DD';

class CRCWeekly extends Component { 
    state = {
        loading: false,
        searchParams: {
            startDate: moment().subtract(moment().day() - 1,'days'),
            endDate: moment().add( 7- moment().day() ,'days'),
        },
        list: [],
        siteTotal: [],
        pagination: {
            current: 1,
        },
        showSite: true,
        invOptions: [],
        siteOptions: [],
        roleList: [],
        investigationSiteId: '',
        investigationSiteCode: '',
        investigationSiteName: '',
    };

    getRoleList = () => {
        const options = {
            url: `${API_URL.manhour.listAllRoles}`,
            data: {},
            dataType: 'json',
            doneResult: ( res => {
                this.setState({ roleList: res.datas });
            }),
        };
        AjaxRequest.sendRequest(options);
    }

    //项目
    invSelectChanged = value => {   
        const { searchParams } = this.state;
        if (value) {
            searchParams.investigationId = value.key;
        } else {
            searchParams.investigationId = '';
        }
        searchParams.investigationSiteId = '';
        this.setState({
            searchParams,
            showSite: false,
            siteOptions: [],
        }, () => {
            this.setState({ showSite: true });
        });
    }

    parseInvData = (res, value) => {
        if (res.data || res.datas) {
            const sourceData = res.data || res.datas;
            const data = sourceData.map(item => ({
                text: `${item.investigationName}`,
                value: item.investigationId,
            }));
            this.setState({ invOptions: data });
        } else {
            this.setState({ invOptions: [] });
        }
    };

    //中心
    siteSelectChanged = value => {   
        const { searchParams } = this.state;
        if (value) {
            searchParams.investigationSiteId = value.key;
        } else {
            searchParams.investigationSiteId = '';
        }
        this.setState({searchParams});
    }

    parseSiteData = (res, value) => {
        if (res.data || res.datas) {
            const sourceData = res.data || res.datas;
            const data = sourceData.map(item => ({
                text: `${item.investigationSiteName}`,
                value: item.investigationSiteId,
            }));
            this.setState({ siteOptions: data });
        } else {
            this.setState({ siteOptions: [] });
        }
    };

    getDynamicParams = () => {
        const { searchParams, invOptions } = this.state;
        const { investigationId } = searchParams;
        if (investigationId){
            const flag = invOptions.some(item => {
                return item.value == investigationId;
            });
            if (!flag) {
                message.warning('请选择正确的临床项目');
                return;
            } else {
                return {investigationId};
            }
        }
        message.warning('请先选择临床项目');
        return null;
    }
    
    onStartChange = (data, dateString) => {
        const { searchParams = {} } = this.state;
        if ( data == null){
            searchParams.startDate = moment().subtract(moment().day() - 1,'days');
            searchParams.endDate = moment().add( 7- moment().day() ,'days');
            this.setState({ searchParams });
            return;
        }
        let dTemp = moment(dateString),
            dTemp1 = moment(dateString);
        searchParams.startDate = dTemp.startOf('week');
        searchParams.endDate = dTemp1.endOf('week');
        this.setState({ searchParams });
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({searchParams});
    }

    searchComponent = () => {
        const { showSite, invOptions, siteOptions, roleList, searchParams } = this.state;
        const { startDate, endDate, investigationId } = searchParams;
        const roleOptions = roleList.map(d => <Option key={d.roleId}>{d.roleCode}</Option>);
        const element = (
            <div className="search-bar" style={{ marginBottom: 16 }}>
                <div className="search-item month-range-picker">
                    <label className="ui-label">工作日期</label>
                        <DatePicker
                            className="begin"
                            format={DateFormat}
                            value={startDate}
                            allowClear={true}
                            onChange={this.onStartChange}
                        />
                        <DatePicker
                            className="end"
                            format={DateFormat}
                            value={endDate}
                            allowClear={true}
                            onChange={this.onStartChange}
                        />
                </div>
                <div className="search-item">
                    <label className="ui-label">临床项目</label>
                    <SearchSelect 
                        style={{width:200}}
                        url = {API_URL.manhour.queryMyInvestigation}
                        searchKey = 'keyword'
                        sourceData={invOptions}
                        parserData={this.parseInvData}
                        watchValue={this.invSelectChanged}
                        handleSelect = {this.invSelectChanged}
                        placeholder={'输入项目或编号自动检索'}
                        allowClear={true}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">中心</label>
                    {
                        showSite &&
                            <SearchSelect 
                            style={{width:200}}
                            url = {API_URL.manhour.queryMyInvestigationSite}
                            searchKey = 'keyword'
                            sourceData={siteOptions}
                            searchParam={{investigationId}}
                            parserData={this.parseSiteData}
                            watchValue={this.siteSelectChanged}
                            handleSelect = {this.siteSelectChanged}
                            getDynamicParams = {this.getDynamicParams}
                            placeholder={'输入中心或编号自动检索'}
                            allowClear={true}
                        />
                    }
                </div>
                <div className="search-item">
                    <label className="ui-label">角色</label>
                    <Select placeholder="请选择" allowClear={true} style={{ width: 80 }} onChange={value => this.handleChange(value, 'roleId')} onFocus={this.getRoleList}>
                        { roleOptions }
                    </Select>
                </div>
                <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    <Button type="primary" onClick={this.export}>导出</Button>
                </div>
            </div>
        );
        return element;
    };

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData({ offset: 1 });
        });
    };

    export = () => {
        const { roleId = '', investigationId = '', investigationSiteId = '', startDate, endDate } =  this.state.searchParams;
        const options = {
            roleId,
            investigationId,
            investigationSiteId,
            startDate: startDate.format(DateFormat),
            endDate: endDate.format(DateFormat),
        };
        this.ExportModalRef.show(options);
    }
    
    showNextWeekPlan = params => {
        const { searchParams } = this.state;
        params.startDate = searchParams.startDate.format(DateFormat);
        params.endDate = searchParams.endDate.format(DateFormat);
        this.addNextWeekPlanRef.show(params);
    }

    loadData = (params = {}) => {
        this.setState({ loading: true });
        const { searchParams, pagination, invOptions, siteOptions } = this.state;
        let { roleId = '', investigationId = '', investigationSiteId = '', startDate, endDate } = searchParams;
        if (investigationId) {
            const falg = invOptions.some(item => {
                return item.value == investigationId;
            });
            if (!falg) {
                investigationId = ''
            }
        }
        if (investigationSiteId) {
            const falg = siteOptions.some(item => {
                return item.value == investigationSiteId;
            });
            if (!falg) {
                investigationSiteId = ''
            }
        }
        const options = {
            url: `${API_URL.manhour.queryManHourWeek}`,
            data: {
                roleId,
                investigationId,
                investigationSiteId,
                startDate: startDate && startDate.format(DateFormat),
                endDate: endDate && endDate.format(DateFormat),
                offset: pagination.current,
                ...params,
            },
            dataType: 'json',
            doneResult: ( res => {
                if (!res.error) {
                    const list = res.datas;
                    const { roleCode } = list[0];
                    let siteTotal;
                    if (roleCode == 'CRC') {
                        siteTotal = res.datas[0].siteTotal || {};
                    } else if (roleCode == 'PM' || roleCode == 'PA') {
                        siteTotal = res.datas[0].invTotal || {};
                    }
                    pagination.total = res.totalCount;
                    this.setState({
                        loading: false,
                        list,
                        siteTotal,
                        pagination,
                        beginWeek: startDate,
                    });
                };
            }),
            errorResult: ( res => {
                pagination.total = 1;
                this.setState({
                    loading: false,
                    list: [],
                    siteTotal: {},
                    pagination,
                    beginWeek: startDate,
                });
            }),
        };
        AjaxRequest.sendRequest(options);
    }

    componentDidMount() {
        this.loadData({ offset: 1 });
    }

    getColumns = () => {
        const { roleCode } = this.state.list[0] || {};
        let title ='';
        if (roleCode == 'CRC') {
            title = '中心';
        } else if (roleCode == 'PM' || roleCode == 'PA') {
            title = '项目';
        }
        return [{
            title: title,
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 110,
            fixed:'left',
            align: 'center',
        }, {
            title: '本周工时数',
            dataIndex: 'manHourString',
            key: 'manHourString',
        }, {
            title: '本周FTE数',
            dataIndex: 'fteString',
            key: 'fteString',
        }, {
            title: '本周筛选数',
            dataIndex: 'amountFilter',
            key: 'amountFilter',
        }, {
            title: '本周知情数',
            dataIndex: 'amountInformed',
            key: 'amountInformed',
        }, {
            title: '本周随机(入组)数',
            dataIndex: 'amountRandom',
            key: 'amountRandom',
            width: 110,
        }, {
            title: '本周完成访视数',
            dataIndex: 'amountVisit',
            key: 'amountVisit',
            width: 110,
        }, {
            title: '本周退出数',
            dataIndex: 'amountDrop',
            key: 'amountDrop',
        }, {
            title: '本周方案违背数',
            dataIndex: 'amountViolation',
            key: 'amountViolation',
            width: 110,
        }, {
            title: '本周SAE数',
            dataIndex: 'amountSae',
            key: 'amountSae',
        }];
    }

    getDataSource = () => {
        const dataSource = [];
        const { siteTotal = {}, list = [] } = this.state;
        const { data = {} } = siteTotal;
        const { dataList = [] } = data;
        const { roleCode } = list[0] || {};

        if (roleCode == 'CRC') {
            if (dataList.length > 0) {
                dataList.map(item => {
                    dataSource.push({
                        ...item,
                        investigationSiteName: `${list[0].investigationSiteName}(${list[0].investigationSiteCode})`,
                    });
                });
            } else {
                list.length > 0 &&
                dataSource.push({
                    investigationSiteName: `${list[0].investigationSiteName}(${list[0].investigationSiteCode})`
                });
            }
        } else if (roleCode == 'PM' || roleCode == 'PA') {
            if (dataList.length > 0) {
                dataList.map(item => {
                    dataSource.push({
                        ...item,
                        investigationSiteName: `${list[0].investigationName}(${list[0].investigationCode})`,
                    });
                });
            } else {
                list.length > 0 &&
                dataSource.push({
                    investigationSiteName: `${list[0].investigationName}(${list[0].investigationCode})`
                });
            }
        }
        return dataSource;
    };

    onChange = page => {
        const { pagination } = this.state;
        pagination.current = page;
        this.setState({ pagination });
        this.loadData({ offset: page });
    }

    getMyWeeklyTable = () => {
        const { loading, list, beginWeek } = this.state;
        const options =  list.map((item, index) =>
            <MyWeeklyTable
                key={index}
                loading={loading}
                beginWeek={beginWeek}
                data={item}
                showNextWeekPlan={this.showNextWeekPlan}
            />
        );
        return options;
    }

    render() { 
        const { loading, pagination, list = [] } = this.state;
        const { total } = pagination;
        const { roleCode = '', investigationName, investigationSiteId } = list[0] || {};
        const isShow = roleCode != 'CRC' && roleCode != 'CRCC' && roleCode != 'CRCM' && investigationName != '日常管理';
        const isCRC = roleCode == 'CRC' && investigationName != '日常管理' && investigationSiteId != null;
        return (
            <div className="content">
                <SideNav selectKey="myWeekly" />
                <div className="main crc-weekly">
                    { this.searchComponent() }
                    { this.getMyWeeklyTable() }
                    {
                        (isShow || isCRC) &&
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.investigationSiteName}
                            loading={loading}
                            scroll={{x: 950}}
                            style={{marginBottom: 40}}
                            pagination={ false }
                        />
                    }
                    <Pagination style={{float: 'right'}} current={pagination.current} onChange={this.onChange} total={total} pageSize={1}/>
                </div>
                <AddNextWeekPlan ref={el => this.addNextWeekPlanRef = el} reload={this.loadData}/>
                <ExportModal ref={el => this.ExportModalRef = el} />
            </div>
        );
    }
}

export default CRCWeekly;


// WEBPACK FOOTER //
// ./src/components/manHour/MyWeekly.js